import cx from 'classnames'
import { useState } from 'react'
import { Link } from 'react-router-dom'

import { API_BASE_PATH_PORTAL } from '../../../api/auth'
import { REDESIGN_ROOT_PATH } from '../../../helpers'
import { BeamButton } from '../../../stories/BeamButton'
import { BeamLogo } from '../../../stories/BeamLogo'
import { BeamTextfield } from '../../../stories/BeamTextfield'
import { BeamInputChangeEvent } from '../../../stories/BeamTextfield/BeamTextfield'
import { axiosRequest } from '../../../utils/axiosRequest'
import { BeamSEO } from '../BeamSEO'
import $$ from './forgot-password-page.module.css'

function sendEmailAxios(email: string) {
  return axiosRequest('post', `${API_BASE_PATH_PORTAL}/v2/users/auth/forgot-password`, {
    email,
    isReskin: true,
  })
}

export const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('')
  const [error, setError] = useState<null | string>(null)
  const [submitted, setSubmitted] = useState(false)

  const captureValue: BeamInputChangeEvent = e => {
    const target = e.target as HTMLInputElement
    setEmail(target.value)
  }

  const sendEmail = async (event: any) => {
    event.preventDefault()
    try {
      await sendEmailAxios(email)
      setSubmitted(true)
    } catch (error: any) {
      console.error(JSON.stringify(error.response.data as object))
      if (error.response?.data) {
        setError(error.response?.data?.detail || error.response?.data?.title)
      } else {
        setError(error.message)
      }
    }
  }

  return (
    <div className={cx($$.forgotPasswordPage, 'w-full h-full beam-bg--gradient-coral')}>
      <BeamSEO title={`Forgot Password`} />
      <div className="flex items-center justify-center h-screen min-h-full px-4 py-12 sm:px-6 lg:px-8">
        <div
          className={cx(
            $$.forgotPasswordForm,
            'flex flex-col items-center justify-center flex-grow w-full h-full max-w-2xl p-2 space-y-8 text-center desktop:p-28 desktop:h-auto'
          )}>
          <BeamLogo alt="Beam Impact Partner Portal - Forgot Password Form" />
          {submitted ? (
            <p>Your reset request was submitted. Please check your email.</p>
          ) : (
            <form onSubmit={sendEmail} className="w-full space-y-6">
              <p>
                Enter your email address. If a user with that address exists, we&apos;ll send you a
                link to reset your password.
              </p>
              <div className="w-full">
                <BeamTextfield name="email" placeholder="Email" onChange={captureValue} autofocus />
              </div>
              <BeamButton label="Submit" variant="elevated" type="submit" />
            </form>
          )}
          <Link to={`${REDESIGN_ROOT_PATH}/login`}>Return to login</Link>
          {error && <p style={{ color: 'var(--beam-color--error)' }}>{error}</p>}
        </div>
      </div>
    </div>
  )
}
